import React, { useMemo } from "react";

function Stepone({
  passes,
  qtyByPass,
  inc,
  dec,
  handleBook,
  openAccordion,
  toggleAccordion,
}) {
  // 🔥 DATE LOGIC
  const activePassType = useMemo(() => {
    const today = new Date();
    const y = 2026; // FIXED YEAR

    const superEarlyEnd = new Date(y, 0, 4); // Jan 4
    const earlyStart = new Date(y, 0, 5); // Jan 5
    const earlyEnd = new Date(y, 1, 8); // Feb 8
    const regularStart = new Date(y, 1, 9); // Feb 9
    const regularEnd = new Date(y, 3, 19); // Apr 19

    if (today <= superEarlyEnd) return "superearly";
    if (today >= earlyStart && today <= earlyEnd) return "earlybird";
    if (today >= regularStart && today <= regularEnd) return "regular";

    return "closed";
  }, []);

  const checkAvailability = (type) => {
    if (activePassType === "closed") return false;
    return type === activePassType;
  };

  return (
    <div className="d-flex justify-content-center py-5">
      <div className="container" style={{ maxWidth: "1200px" }}>
        <h3 className="fw-bold mb-5 text-center">Delegate Registration</h3>

        {/* Pass Cards */}
        <div className="row g-4 justify-content-center">

          {passes.map((pass) => {
            const available = checkAvailability(pass.type);

            return (
              <div key={pass.id} className="col-md-6 col-lg-4">
                <div
                  className={`pass-card rounded p-5 d-flex flex-column justify-content-between text-center ${
                    pass.highlight ? "highlight" : ""
                  }`}
                >
                  {pass.highlight && (
                    <div className="limited-badge">LIMITED TICKETS AVAILABLE</div>
                  )}

                  {/* 🔥 LABEL FOR LOCKED PASSES */}
                  {!available && (
                    <p className="text-danger fw-bold small mb-2">
                      Not available in this window
                    </p>
                  )}

                  <div>
                    <h5 className="fw-bold">{pass.title}</h5>
                    <p className="text-muted">{pass.subtitle}</p>

                    <div className="delegate-box mb-3">
                      <label className="small fw-semibold d-block mb-2">
                        Number of Delegates
                      </label>

                      <div className="counter-box d-flex align-items-center justify-content-center mx-auto">
                        <button
                          className="counter-btn"
                          onClick={() => available && dec(pass.id)}
                          disabled={!available}
                        >
                          -
                        </button>

                        <span className="mx-3">{qtyByPass[pass.id]}</span>

                        <button
                          className="counter-btn"
                          onClick={() => available && inc(pass.id)}
                          disabled={!available}
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <h4 className="fw-bold mt-2">
                      US${pass.price}{" "}
                      {pass.oldPrice && pass.oldPrice !== pass.price && (
                        <small className="text-muted text-decoration-line-through">
                          (US${pass.oldPrice})
                        </small>
                      )}
                    </h4>
                  </div>

                  <button
                    className="btn btn-primary mt-3 w-100"
                    onClick={() => available && handleBook(pass)}
                    disabled={!available}
                    style={!available ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                  >
                    {available ? "Book Now" : "Unavailable"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Accordion */}
        <div className="accordion mt-5">
          {[
            {
              key: "group",
              title: "Group Pass Discounts",
              content: (
                <>
                  <p>
                    Accelerate learning and build a shared vision by attending as a group.
                    Receive complimentary registration(s) when you register as a team.
                  </p>
                  <ul>
                    <li>Group of 2 - 10%</li>
                    <li>Group of 3 - 15%</li>
                    <li>Group of 5 - 20%</li>
                  </ul>
                </>
              ),
            },
            {
              key: "payment",
              title: "Payment Terms",
              content: (
                <p>
                  A valid credit card is required to purchase a conference pass.
                </p>
              ),
            },
            {
              key: "cancel",
              title: "Cancellation Policy",
              content: (
                <p>
                  Event registrations may be transferred at the sole discretion of
                  aroevents. Please refer to info@aroevents.com.
                </p>
              ),
            },
          ].map((item) => (
            <div key={item.key} className="accordion-item border-bottom py-3">
              <button
                className="accordion-header w-100 text-start fw-bold d-flex justify-content-between"
                onClick={() => toggleAccordion(item.key)}
              >
                {item.title}
                <span>{openAccordion === item.key ? "-" : "+"}</span>
              </button>

              {openAccordion === item.key && (
                <div className="accordion-body small text-muted mt-2">
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Styles kept EXACTLY as given */}
        <style>{`
          .pass-card {
            background: #fff;
            border: 1px solid #eee;
            min-height: 420px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            transition: transform 0.2s;
            padding: 2.5rem;
          }
          .pass-card:hover { transform: translateY(-8px); }
          .pass-card.highlight { background: #fffbea; border: 1px solid #f0c040; }

          .limited-badge {
            background: #a56300; 
            color: #fff; 
            font-size: 0.75rem;
            font-weight: 600; 
            padding: 4px 10px; 
            border-radius: 4px;
            display: inline-block; 
            margin-bottom: 10px;
          }

          .counter-box {
            border: 1px solid #ccc; 
            border-radius: 25px;
            padding: 8px 16px; 
            background: #fafafa;
          }
          .counter-btn {
            width: 40px; 
            height: 40px; 
            border-radius: 50%;
            border: 1px solid #ccc; 
            background: #fff; 
            font-weight: bold;
            cursor: pointer; 
            transition: all 0.2s;
          }
          .counter-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          .counter-btn:hover { background: #f1f1f1; }

          .btn-primary {
            background: #0070f3; 
            border: none; 
            color: #fff;
            font-weight: 600; 
            border-radius: 30px; 
            padding: 12px 0;
          }
          .btn-primary:hover { background: #0059c1; }
          .btn-primary:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .accordion-header { background: none; border: none; font-size: 1rem; }
          .accordion-body { padding-left: 5px; }

        `}</style>
      </div>
    </div>
  );
}

export default Stepone;
